import http from '@/util/http-common'

class WifiManagementDataService {
  send (id, isGroup, action, data = {}) {
    return http.post(`/${isGroup ? 'device-groups' : 'devices'}/${id}/wifi/${action}`, data)
  }

  results (deviceId, limit = 50) {
    return http.get(`/devices/${deviceId}/wifi/results`, { params: { limit } })
  }

  token (deviceId) {
    return http.post(`/devices/${deviceId}/wifi/token`, {})
  }

  companyDefault (companyId) {
    return http.get(`/WifiConfig/company/${companyId}`)
  }

  companyForDevice (macAddress) {
    return http.get(`/Company/get-company-by-macaddress/${encodeURIComponent(macAddress)}`)
  }

  device (deviceId) {
    return http.get('/Device/GetById', { params: { id: deviceId } })
  }
}

export default new WifiManagementDataService()
